import React, { useEffect } from "react";
import styles from "./MfDataTransmission.module.css";
import ModalInputField from "components/shared/modal/ModalInputField";
import { useMfImport } from "features/compositions/context/MfImportContext";
import { formatBytes } from "lib/formatBytes";
import useTheme from "config/useTheme";
import ActionProgress from "components/shared/status/ActionProgress";
import { useUploadMf } from "features/compositions/services/useMfImportService";
import ActionProgressSuccess from "components/shared/status/ActionProgressSuccess";
import { useCalcCreateCompProgress } from "config/useCalculationFramework";
import ActionProgressFailed from "components/shared/status/ActionProgressFailed";
import { validateFieldName } from "utils/validations";
import { useNavigate } from "react-router-dom";
import { useModalSystem } from "config/context/ModalSystemContext";

const MfDataTransmission = () => {
    const navigate = useNavigate();
    const { dark } = useTheme();
    const { hideModal } = useModalSystem();
    const stepInterval = useCalcCreateCompProgress();
    const {
        file,
        instance,
        setInstance,
        selectedPermission,
        pkey,
        exist,
        selectedComposition,
        table,
        resetMfContext
    } = useMfImport();

    const { response, loading, error, uploadMf, resetServerStatus } =
        useUploadMf();

    const type = file?.name ? file.name.split(".").pop().toLowerCase() : "";

    const data = {
        permission: "active",
        private_key: pkey,
        exist: exist,
        scope: instance,
        compositions: [
            {
                name: selectedComposition,
                fields: table.fields.filter((f) => !f.is_index),
                indexes: table.fields.filter((f) => f.is_index),
                permission: selectedPermission,
            },
        ],
        file: file,
    };

    const handleUpload = () => {
        if (!validateFieldName(instance)) { return; }
        uploadMf({ type, data });

    };

    const onProgressClose = () => {
        resetMfContext();
    }

    useEffect(() => {
        if (response?.status) {
            setTimeout(() => {
                hideModal();
                navigate(`/compositions?composition=${response?.data?.compositions[0]?.name}&scope=${instance}`);
            }, 2000);
        }
    }, [response]);

    return (
        <div className={`${styles.data_transmission} ${dark ? styles.dark : ""}`}>
            <div className={styles.transmission_info}>
                <p>
                    file name: <span>{file?.name}</span>
                </p>
                <p>
                    file size: <span>{formatBytes(file?.size)}</span>
                </p>
            </div>
            <div className={styles.insert_instance}>
                <p>
                    Specify the target instance for this data.
                </p>
                <ModalInputField
                    placeholder="Instance"
                    value={instance}
                    setValue={(val) => setInstance(val)}
                    validator={(val) => validateFieldName(val)}
                />
            </div>
            {loading && <ActionProgress stepInterval={stepInterval} />}
            {response?.status && <ActionProgressSuccess message={response?.message} onClose={onProgressClose} />}
            {response && !response?.status && <ActionProgressFailed message={response?.message} details={response?.error} onClose={onProgressClose} />}
            <button
                disabled={!validateFieldName(instance)}
                className={styles.submit_btn}
                onClick={() => handleUpload()}
            >
                Start data transmission
            </button>
        </div>
    );
};

export default MfDataTransmission;